<div class="container">
  <div class="form-container">
    <h3>Contact Us</h3>
    <p>
      Our support team is dedicated to quickly helping you solve any problem.
    </p>

    <form [formGroup]="form">

      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="name" placeholder="Name *">
        </div>

        @if (form.controls.name.touched) {
          <div class="alert">

            @if (form.controls.name.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>

      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="email" placeholder="Email *">
        </div>

        @if (form.controls.email.touched) {
          <div class="alert">

            @if (form.controls.email.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
            @if (form.controls.email.hasError('email')) {
              <div class="form-validation-error">
                Incorrect email
              </div>
            }
          </div>
        }
      </div>

      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="subject" placeholder="Subject *">
        </div>

        @if (form.controls.subject.touched) {
          <div class="alert">

            @if (form.controls.subject.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>
      <div class="pb-12">
        <div class="custom-select">
          <mat-select formControlName="reason" placeholder="Reason *">
            @for (item of reasons; track item) {
              <mat-option [value]="item">{{item}}</mat-option>
            }
          </mat-select>
        </div>
      </div>

      <div class="pb-12">
        <textarea formControlName="message" class="custom-textarea" rows="5" placeholder="Enter message"></textarea>

        @if (form.controls.message.touched) {
          <div class="alert">

            @if (form.controls.message.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
            @if (form.controls.message.hasError('maxlength')) {
              <div class="form-validation-error">
                Max length is {{maxMessageLength}} symbols.
              </div>
            }
          </div>
        }
      </div>

      <button matButton="filled" class="button-regular w-100 pb-12" [disabled]="form.invalid" (click)="send()">Submit</button>

    </form>

  </div>

</div>


